import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function getNestedProperty(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((current, key) => current?.[key], obj);
}

export const NavigationSection = ({
  title,
  routes,
  section,
  config,
  features,
  onNavigate,
}) => {
  const location = useLocation();

  const filteredRoutes = routes.filter((route) => {
    if (section?.config_required && !config?.[section.config_required])
      return false;
    if (route.config_required && !config?.[route.config_required]) return false;

    if (
      route.client_id_required &&
      config?.client_id !== route.client_id_required
    )
      return false;

    if (route.feature_bypass_config && config?.[route.feature_bypass_config])
      return true;

    if (route.feature_path) {
      const featureValue = getNestedProperty(features, route.feature_path);
      return featureValue === true;
    }

    return true;
  });

  if (filteredRoutes.length === 0) return null;

  return (
    <div className="tw-mt-8 tw-px-2">
      <div className="tw-border-solid tw-border-0 tw-border-b tw-border-white/50 tw-pb-3">
        <div className="tw-text-[11px] tw-leading-[13px] tw-text-text-light-high-importance tw-font-work tw-font-medium tw-mb-3 tw-ml-2">
          {title}
        </div>
        {filteredRoutes.map((route, index) => {
          const isExternal = route.url_path.startsWith('http');
          const isParentActive = location.pathname.startsWith(route.url_path);

          if (isExternal) {
            return (
              <React.Fragment key={`${route.url_path}${index}`}>
                <a
                  key={`${route.url_path}${index}`}
                  href={route.url_path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-no-underline"
                  onClick={onNavigate}
                >
                  <div className="tw-rounded-md tw-cursor-pointer tw-mb-[3px] tw-px-3 tw-py-1.5 tw-leading-[1.2] hover:tw-bg-main-hover">
                    <div className="tw-text-sm tw-font-work tw-text-text-light-high-importance">
                      {route.section_title}
                    </div>
                  </div>
                </a>
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={`${route.url_path}${index}`}>
              <Link
                key={`${route.url_path}${index}`}
                className="tw-no-underline"
                to={route.url_path}
                onClick={onNavigate}
              >
                <div
                  className={`tw-rounded-md tw-cursor-pointer tw-mb-[3px] tw-px-3 tw-py-2 ${
                    location.pathname === route.url_path
                      ? 'tw-bg-main-active'
                      : 'hover:tw-bg-main-hover'
                  }`}
                >
                  <div className="tw-text-sm tw-font-work tw-text-text-light-high-importance">
                    {route.section_title}
                  </div>
                </div>
              </Link>
              {isParentActive &&
                route.subsections &&
                route.subsections.map((subsection, index) => {
                  return (
                    <Link
                      className="tw-no-underline"
                      key={`${subsection.url_path}${index}`}
                      to={subsection.url_path}
                      onClick={onNavigate}
                    >
                      <div
                        className={`tw-rounded-md tw-cursor-pointer tw-mb-[3px] tw-px-6 tw-py-1.5 tw-leading-[1.2] ${location.pathname === subsection.url_path ? 'tw-bg-main-active' : 'hover:tw-bg-main-hover'}`}
                      >
                        <div className="tw-text-sm tw-font-work tw-text-text-light-high-importance">
                          {subsection.subsection_title}
                        </div>
                      </div>
                    </Link>
                  );
                })}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
